import { createRoute } from 'atomic-router';

export const routeFromHeaderToMobileSearch = createRoute();
